// Ruta: packages/shared/src/i18n/index.ts

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import cmsEs from './locales/es/cms.json'
import commonEs from './locales/es/common.json'
import dashboardEs from './locales/es/dashboard.json'
import errorsEs from './locales/es/errors.json'

export const defaultNS = 'common'

export const resources = {
  es: {
    common: commonEs,
    dashboard: dashboardEs,
    errors: errorsEs,
    cms: cmsEs,
  },
} as const

i18n.use(initReactI18next).init({
  resources,
  lng: 'es',
  fallbackLng: 'es',
  defaultNS,
  ns: ['common', 'dashboard', 'errors', 'cms'],
  interpolation: {
    escapeValue: false, // React already escapes by default
  },
  react: {
    useSuspense: false,
  },
})

export default i18n
